import React from 'react';
import { GaugeIcon } from 'lucide-react';
export function SiteFooter() {
  return <footer className="w-full border-t border-white/5 bg-steel-900 px-6 pb-28 pt-14" data-id="element-180" data-mp="3r89h9jm4jdlp">
      <div className="mx-auto max-w-4xl text-center" data-id="element-181" data-mp="3raluxkkun1sy">
        <p className="flex items-center justify-center gap-2 font-display text-xl font-semibold uppercase tracking-wide text-ink-50" data-id="element-182" data-mp="3mg85dysvbow7">
          <GaugeIcon className="h-5 w-5 text-ember-400" aria-hidden="true" data-id="element-183" data-mp="3hgdc5olmen7z" />
          Industrial Instrumentation Instructor System 2026
        </p>
        <p className="mt-4 text-base text-ink-400" data-id="element-184" data-mp="38hi5kbenzb45">
          Built by plant-floor engineers and classroom instructors, for educators who refuse to teach
          outdated automation.
        </p>
        <p className="mx-auto mt-8 max-w-2xl text-sm leading-relaxed text-ink-500" data-id="element-185" data-mp="2ykdm4jc7dtr1">
          The IIIS 2026 is a digital instructional resource. Content must be adapted to the standards,
          safety regulations and accreditation requirements in force at your institution; it does not
          replace professional engineering judgment or formal certification.
        </p>
        <nav aria-label="Legal links" className="mt-8 flex justify-center gap-6 text-sm" data-id="element-186" data-mp="1apopl3fqiukn">
          <a href="#terms" className="text-ink-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-ember-400 hover:underline" data-id="element-187" data-mp="vspakuijzzg5">
            Terms & Conditions
          </a>
          <a href="#privacy" className="text-ink-200 underline-offset-4 transition-colors duration-150 ease-out hover:text-ember-400 hover:underline" data-id="element-188" data-mp="1ohcxsvmv4ywc">
            Privacy Policy
          </a>
        </nav>
        <p className="mt-8 border-t border-white/[0.08] pt-6 text-xs text-ink-500" data-id="element-189" data-mp="1erjqi6tr75xw">
          © 2026 Industrial Instrumentation Instructor System — All rights reserved.
        </p>
      </div>
    </footer>;
}